import { FormattedMessage } from 'react-intl';

import { supplierGridProperties } from '../../data/suppliers-properties';
import { messages } from '../messages';

type SupplierData = {
  contactName: string;
};

const name = <FormattedMessage {...messages.supplierContactNameColumnHeader} />;

/**
 * Contact Name column configuration
 * Displays the contact name for suppliers
 */
export const supplierContactName = {
  name,
  render: (data: SupplierData) => data.contactName,
  id: supplierGridProperties.contactName,
};
